import * as HttpService from "../../../../service/HttpService";


/**
 *查询运动员档案列表
 */
export const queryHousekeeperList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/housekeeper/queryHousekeeperList", params);
};

/**
 *查询管家助手Table列表
 */
export const queryHousekeeperTableList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/housekeeper/queryHousekeeperTableList", params);
};

/**
 *查询管家助手Table列表
 */
export const queryHousekeeperDetail = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/housekeeper/queryHousekeeperDetail", params);
};

